export default __webpack_public_path__ + "static/media/gallery_06.a7998c7a.jpg";